var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepper-container"},[_c('v-stepper',{staticClass:"stepper",attrs:{"value":_vm.step,"alt-labels":"","color":"secondary"}},[_c('v-stepper-header',[_vm._t("content")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }